import React from 'react';
import HeaderStrip from '../ui/HeaderStrip';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  block: {
    display: 'block',
  },
  smallContainer: {
    [theme.breakpoints.down('md')]: {
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
    },
  },
}));

function BodyContainer(props) {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Container>
        <Paper elevation={0}>
          <Box display="flex" justifyContent="center" alignItems="center">
            <Grid container>
              <Grid item md={2} xs={'auto'} sm={'auto'}></Grid>
              <Grid
                item
                container
                md={8}
                xs={12}
                sm={'auto'}
                component="div"
                className={classes.smallContainer}
              >
                <Grid container item xs={12}>
                  <HeaderStrip title={props.title} icon={props.icon} />
                </Grid>
                <Grid container item xs={12} justify="center">
                  {props.children}
                </Grid>
              </Grid>
              <Grid item md={2} xs={'auto'} sm={'auto'}></Grid>
            </Grid>
          </Box>
        </Paper>
      </Container>
    </div>
  );
}

export default BodyContainer;
